// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LYhS","content":"styles_content__maL6L"};